<script>
/** Utilities */
import {mapState,mapMutations} from 'vuex'
import ArrayUtil from '../../utilities/ArrayUtil'
import Cleave from 'cleave.js'
import AppResourceUtil from '../../utilities/AppResourceUtil'
import BrowserDataUtil from '../../utilities/BrowserDataUtil'
/** APIs */
import UserApi from '../../api/UserApi'
import IssueApi from '../../api/IssueApi'
import ValidationCardApi from '../../api/ValidationCardApi'
import VfeApi from '../../api/VfeApi'
import ReportingEntityApi from '../../api/ReportingEntityApi'
import ReportingUnitApi from '../../api/ReportingUnitApi'
import FormsApi from '../../api/FormsApi'
import FilesApi from '../../api/FilesApi'
/** Constants */
import { FileTypes } from '../../constants/FileTypes'
import { BACKEND_URL } from '../../constants/ServiceUrl'
/** UI Components */
import { Checkbox } from 'buefy/dist/components/checkbox'
import { Collapse } from 'buefy/dist/components/collapse'
import { Datepicker } from 'buefy/dist/components/datepicker'
import { Autocomplete } from 'buefy/dist/components/autocomplete'
import { Dropdown, DropdownItem } from 'buefy/dist/components/dropdown'
import { Field } from 'buefy/dist/components/field'
import { Switch } from 'buefy/dist/components/switch'
import { Icon } from 'buefy/dist/components/icon'
import { Input } from 'buefy/dist/components/input'
import { Modal } from 'buefy/dist/components/modal'
import { Radio } from 'buefy/dist/components/radio'
import { Select } from 'buefy/dist/components/select'
import { Tabs,TabItem } from 'buefy/dist/components/tabs'
import { Loading } from 'buefy/dist/components/loading'
import { Upload } from 'buefy/dist/components/upload'
import { Message } from 'buefy/dist/components/message'
import SummaryTab from '../../components/SummaryTab'

/**
 * We add a new instance of Cleave when the element
 * is bound and destroy it when it's unbound.
 */
const cleave = {
    name: 'cleave',
    bind(el, binding) {
        const input = el.querySelector('input')
        input._vCleave = new Cleave(input, binding.value)
    },
    unbind(el) {
        const input = el.querySelector('input')
        input._vCleave.destroy()
    }
}

export default {
    name : "WorkspacePreview",
    components : {
        'b-checkbox' : Checkbox,
        'b-collapse' : Collapse,
        'b-field' : Field,
        'b-icon' : Icon,
        'b-input' : Input,
        'b-select' : Select,
        'b-modal' : Modal,
        'b-tabs' : Tabs,
        'b-tab-item' : TabItem,
        'b-dropdown' : Dropdown,
        'b-dropdown-item' : DropdownItem,
        'b-datepicker' : Datepicker,
        'b-radio' : Radio,
        'b-loading' : Loading,
        'b-upload' : Upload,
        'b-autocomplete' : Autocomplete,
        'b-message' : Message,
        'b-switch' : Switch,
        SummaryTab
    },
    directives: { cleave },
	computed : {
		...mapState({
            activeNav : "activeNav",
            profile : "userProfile",
            token : "xOreAuth"
        }),
        isAdmin () {
            if (this.profile) {
                if (this.profile.role.match(/admin|administrator/gi)) {
                    return true
                }
            }
            return false
        },
        groupedFields(){
            if (this.selectedVfe) {
                let currFieldGroup=null;
                let newGroupedFields = [];
                if ( this.selectedVfe.formFields ) {
                    if ( this.selectedVfe.formFields.length > 0) {
                        this.selectedVfe.formFields.forEach(field=>{
                            if (field.fieldGroupLabel==currFieldGroup && field.fieldGroupLabel!="") {
                                newGroupedFields[newGroupedFields.length-1].fields.push(field)
                            }
                            else {
                                newGroupedFields.push({
                                    fieldGroupName: field.fieldGroupLabel,
                                    fieldGroupSubLabel: field.fieldGroupSubLabel ? field.fieldGroupSubLabel : '',
                                    fields : [field]
                                })
                            }
                            currFieldGroup = field.fieldGroupLabel;
                        });
                    }
                } 
                return newGroupedFields;
            }
        },
        filterValidationEntryForms(){
            var searchKeyword = this.searchFormKeyword;
            var searchExp = new RegExp(searchKeyword,"i");
            if (this.vcardForms) {
                if (this.vcardForms.length > 0) {
                    return this.vcardForms.filter(form=>{
                        return (form.formName.match(searchExp));
                    });
                }
            }
        },
        fValue: {
            get:function(){ 
                return this.taxValue;
            },
            set:function(newValue) {
                this.taxValue = newValue.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
                // Source:
                // https://blog.abelotech.com/posts/number-currency-formatting-javascript/
                // https://codesandbox.io/s/p7j447k7wq
            }
        },
        vcardDisplayName(){
            if (this.selectedValidationCard) {
                if (this.selectedValidationCard.reportingUnit) {
                    return this.selectedValidationCard.reportingUnit;
                }
                return this.selectedValidationCard.reportingEntity;
            }
        },
        baseUrl(){
            return BACKEND_URL;
        },
        filteredVcards(){
            if (!this.vcardKeyword) {
                return this.inProgressVcards;
            } 
            return this.inProgressVcards.filter((option) => {
                try {
                    return option.displayedEntityName
                        .toString()
                        .toLowerCase()
                        .indexOf(this.vcardKeyword.toLowerCase()) >= 0
                }
                catch(err){
                    console.log(err)
                }
            })
        },
        formsWithFiles () {
            if (this.vcardForms.length > 0) {
                return this.vcardForms.filter(form=>{
                    if (this.withFiles) {
                        return (form.vcardFiles && form.vcardFiles.length > 0)
                    }
                    return form
                })
            }
            return this.vcardForms
        },
        intSelectedVcardId () {
            if (this.selectedValidationCardId) {
                return parseInt(this.selectedValidationCardId, 10)
            }
            return this.selectedValidationCardId
        }
    },
    data(){
        return {
            activeTab : 0,
            activeFormEntry: null,
            activeValidationEntry : null,
            displayOption : "list",
            formTableColumns : [],
            selectedForm: null,
            searchFormKeyword: "",
            taxValue: "",


            selectedValidationCardId : null,
            selectedValidationCard : null,
            vcardForms : [],
            vcardLogs : [],
            selectedReportingYear : null,
            reportingYearLov : [],
            inProgressVcards : [],
            selectedVfe : null,
            vfePromiseLoading : false,
            presetLovs: {
                'Reporting Entities' : [],
                'Reporting Entities & Units' : []
            },
            showList : true,
            masks: {
                numeral: {
                    numeral: true,
                    numeralThousandsGroupStyle: 'thousand',
                    prefix: '',
                    rawValueTrimPrefix : true
                }
            },
            dropFiles : [],
            fileUploadError : false,
            fileUploadErroMsg : "",
            openVfeFilesDialog : false,
            openedVfe : null,
            isLoading : false,
            isFullPage : false,
            vcardKeyword : '',
            globalLoading: null,
            withFiles: true,
            downloadSize: null
        }
    },
    created(){
        if (!this.profile) {
            this.clearSession();
            return false;
        }
        this.isTokenValid();
    },
    mounted(){
        // this.$refs['formIdx1'][0].open = false;
        // this.$refs['formIdx2'][0].open = false;
    },  
    methods : {
        ...mapMutations({
            clearAppData : "clearAppData",
            setActiveNav : "updateActiveNav",
            setProfile : "updateUserProfile"
        }),
        isTokenValid(){
            if (!this.token) {
                this.clearSession();
                return false
            }
            UserApi.isTokenValid({
                token : this.token
            })
            .then(response=>{
                if (response.data){
                    if (response.data.length > 0) {
                        let data = response.data[0];
                        if (data.dateCreated) {
                            let a = this.$moment();
                            let b = this.$moment(data.dateCreated,'YYYY-MM-DD HH:mm:ss');
                            let duration = a.diff(b, 'days');
                            if (duration >= 1 ) {
                                // Session is expired
                                this.logOut()
                            }
                            else {
                                // Session is still active
                                // Default call in created
                                let vcardId = '';
                                let vcardYear = null;
                                if (this.$route.query) {
                                    try {
                                        vcardId = this.$route.query.validationCardId;
                                    }
                                    catch(cardId){}  
                                    try {
                                        vcardYear = this.$route.query.reportingYear;
                                    }
                                    catch(cardId){}  
                                }
                                this.getReportingYearLov(vcardId,vcardYear);
                                this.getPresetLovs();
                            }
                        }
                    }
                    else {
                        if (response.data.hasOwnProperty('error')) {
                            this.promptServerError({response},'User.isSessionValid');
                            return false;
                        }
                        this.logOut();
                        return false;
                    }
                } 
            })
            .catch(error=>{
                this.promptServerError(error,'User.isSessionValid');
            });
        },
        logOut(){   
            if (this.token) {
                let data = {
                    token : this.token
                }
                if (this.profile) {
                    data.userIdFk = this.profile.userId
                }
                // End session from back-end
                UserApi.endSession(data)
                .then(response=>{
                    if (response.data) {
                        if (response.data.isDeleted) {
                            this.clearSession();
                        }
                    }
                })
                .catch(error=>{
                })
            }
            else {
                // Remove session data from client-side
                this.clearSession();
            }
        },
        clearSession(){
            BrowserDataUtil.clearBrowserData(this.$cookies);
            this.clearAppData();
            this.$router.push({path:"/login"})
        },
        getPresetLovs(){
            this.presetLovs['Reporting Entities'] = [];
            this.presetLovs['Reporting Entities & Units'] = [];

            /* Reporting Entities Preset */ 
            ReportingEntityApi.get('active')
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        let entities = response.data;
                        if (entities.length > 0) {
                            entities.forEach(ent=>{
                                ent.optionLabel = ent.reportingEntity
                            });
                        }
                        this.presetLovs['Reporting Entities'] = entities;
                    }
                    else {
                        this.promptServerError({response},'ReportingEntity.get');
                        return false;
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'ReportingEntity.get');
                return false;
            });

            /* Reporting Entities & Units Preset */ 
            ReportingUnitApi.getUnitsEntities()
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        let entities = response.data;
                        if (entities.length > 0) {
                            entities.forEach(ent=>{
                                ent.optionLabel = ent.reportingEntity
                            });
                        }
                        this.presetLovs['Reporting Entities & Units'] = entities;
                    }
                    else {
                        this.promptServerError({response},'ReportingUnit.getUnitsEntities');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'ReportingUnit.getUnitsEntities');
            });
        },
        getReportingYearLov(vcardId,vcardYear){
            // this.isLoading = true;
            this.showLoading()
            this.reportingYearLov = [];
            let staticYrs = AppResourceUtil.getRepYrStaticLov();

            ValidationCardApi.getReportingYearLov()
            .then(response=>{
                let repYearInDb = [];
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.length > 0) {
                            repYearInDb = response.data.map(yr=>{
                                return (yr.reportingYear);
                            });
                        }
                        
                        /* Merge static years and rep year found in the database */ 
                        let allRepYrsLov = this.$_.union(staticYrs,repYearInDb);

                        /* Sort the years in descending order */ 
                        this.reportingYearLov = allRepYrsLov.sort().reverse();

                        if (!vcardYear) {
                            if (repYearInDb > 0) {
                                try {
                                    /* Pre-select the year with data (from DB) */ 
                                    this.selectedReportingYear = repYearInDb[0];
                                }
                                catch(yrErr){}
                            }
                        }
                        else {
                            this.selectedReportingYear = vcardYear;
                        }

                        if (this.selectReportingYear != null) {
                            this.getInProgressVcards(vcardId);
                        }
                        else {
                            // this.isLoading = false;
                            this.closeLoading()
                        }
                    }
                    else {
                        // this.isLoading = false;
                        this.closeLoading()
                        this.promptServerError({response},'ValidationCard.getReportingYearLov');
                    }
                }
                
            })
            .catch(error=>{
                // this.isLoading = false;
                this.closeLoading()
                this.promptServerError(error,'ValidationCard.getReportingYearLov');
            });
        },
        getInProgressVcards(vcardId){
            this.inProgressVcards = []
            let repUnitIds = this.profile.reportingUnits.map(ru=>{
                return ru.repUnitIdFk;
            })
            // getInProgress
            ValidationCardApi.getNotBacklog({
                userId : this.profile.userId,
                repGroupIdFk : this.profile.repGroupIdFk,
                repEntityIdFk : this.profile.repEntityIdFk,
                repUnitIds,
                reportingYear : this.selectedReportingYear
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        // this.inProgressVcards = response.data.vcards;
                        let vcards = response.data.vcards;
                        vcards.forEach(card=>{
                            card.displayedEntityName = card.reportingUnit ? card.reportingUnit : card.reportingEntity
                        })
                        this.inProgressVcards = vcards;

                        if (vcardId!='' && vcardId!==undefined) {
                            if (this.inProgressVcards.length > 0) {
                                this.selectedValidationCardId = vcardId;
                                this.getValidationCard();
                            }
                            else {
                                // this.isLoading = false;
                                this.closeLoading()
                            }
                        }
                        else {
                            // this.isLoading = false;
                            this.closeLoading()
                        }
                    }
                    else {
                        // this.isLoading = false;
                        this.closeLoading()
                        this.promptServerError({response},'ValidationCard.getInProgress');
                    }
                }
            })
            .catch(error=>{
                // this.isLoading = false;
                this.closeLoading()
                this.promptServerError(error,'ValidationCard.getInProgress');
            });
        },
        getValidationCard(){
            if (!this.selectedValidationCardId) {
                this.closeLoading()
                return false;
            }
            this.vcardForms = [];
            ValidationCardApi.get(this.selectedValidationCardId)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.validationCard.length == 1) {
                            var vcardData = response.data.validationCard[0];
                            vcardData.dateLastUpdated = AppResourceUtil.convertDate(vcardData.dateLastUpdated)
                            vcardData.displayedEntityName = vcardData.reportingUnit ? vcardData.reportingUnit : vcardData.reportingEntity;
                            this.selectedValidationCard = vcardData;//response.data.validationCard[0];
                        }
                        this.selectedReportingYear = this.selectedValidationCard.reportingYear;
                        // this.vcardForms = response.data.uniqueForms;
                        this.vcardLogs = [];

                        /** Convert dates */
                        var vcardForms = response.data.uniqueForms;
                        vcardForms.forEach(vform=>{
                            if (vform.vfe.length > 0) {
                                vform.vfe.forEach(vcardFormEntry=>{
                                    vcardFormEntry.dateLastUpdated = AppResourceUtil.convertDate(vcardFormEntry.dateLastUpdated)
                                    vcardFormEntry.dateGenerated = AppResourceUtil.convertDate(vcardFormEntry.dateGenerated)
                                })
                            }
                            vform.vcardFiles = []
                        })
                        this.vcardForms = vcardForms;

                        if (response.data.logs.length > 0) {
                            let logs = response.data.logs;
                            logs.forEach(log=>{
                                if (log.activityMessageLog=='Changed fields.' ||
                                    log.activityMessageLog=='Saved form entry. Changed fields.') {
                                    log['changedFields'] = JSON.parse(log.activityBody);
                                }
                                if (log.activityReason!=null && log.activityRequestedBy!=null) {
                                    log.additionalInfo = JSON.parse(log.activityBody);
                                }
                                /** Convert Date */
                                log.activityDate = AppResourceUtil.convertDate(log.activityDate)
                            });
                            this.vcardLogs = logs;
                        }
                        // this.isLoading = false;
                        this.closeLoading()
                    }
                    else {
                        // this.isLoading = false;
                        this.closeLoading()
                        this.promptServerError({response},'ValidationCard.get');
                    }
                }
            })
            .catch(error=>{
                // this.isLoading = false;
                this.closeLoading()
                this.promptServerError(error,'ValidationCard.get');
            });
        },
        selectReportingYear(){
            // this.getActiveValidationCards();
            this.selectedValidationCard = null
            this.selectedValidationCardId = null
            this.selectedVfe = null
            this.vcardKeyword = ''
            this.getInProgressVcards();
        },
        selectVcard(option){
            this.selectedForm = null;
            this.selectedVfe = null;
            this.selectedValidationCard = option
            if (option) {
                this.selectedValidationCardId = parseInt(option.validationCardId,10)
                this.vcardKeyword = option.displayedEntityName
            }
            else {
                this.selectedValidationCardId = null
            }
            this.showList = true
            if (this.selectedValidationCardId!=null) {
                this.getValidationCard();
            }
            else {
                this.vcardForms = []
            }
        },
        toggleList(){
            this.showList = !this.showList;
        },
        changeDisplay(option){
            let prevOption = this.selectedForm.displayOption;
            if (this.selectedForm) {
                if (prevOption=='Table' && option=='List') {
                    if (this.selectedForm.vfe.length > 0) {
                        try {
                            this.openFormEntry(this.selectedForm.vfe[0],this.selectedForm,'changeDisplay');
                        }
                        catch(err) {
                        }
                    }
                    if (this.selectedForm.displayOption) {
                        this.selectedForm.displayOption = option;
                    }
                }
                else {
                    if (this.selectedVfe) {
                        this.selectedVfe = null;
                    }
                    /** this.selectedForm.formSubmissionType=='Single' */
                    if (this.selectedForm.vfe.length > 0) {
                        try {
                            this.vfePromiseLoading = true;
                            this.openFormTable(this.selectedForm,option);
                        }
                        catch(vfeFormErr){}
                    }
                }
            }
        },
        openFormEntry(vfe,form,trigger){
            this.vfePromiseLoading = true;
            if (!trigger) {
                this.selectedForm = form;
            }
            VfeApi.get(vfe.vcardFormEntryId,vfe.formIdFk)
            .then(response=>{
                this.selectedVfe = vfe;
                this.$set(this.selectedVfe,'formFields',[]);
                this.$set(this.selectedVfe,'files',[]);

                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.fields) {
                            this.$set(this.selectedVfe,'formFields',response.data.fields);
                            /* Parse date field to be consumed by the datepicker element */
                            if (this.selectedVfe.formFields) {
                                this.selectedVfe.formFields.forEach(field=>{
                                    if (field.dataType=='string' && field.fieldAnswerValue==null) {
                                        field.fieldAnswerValue = "";
                                    }
                                    if (field.dataType=='date') {
                                        if (field.fieldAnswerValue!='' && field.fieldAnswerValue!=null) {
                                            field.fieldAnswerValue = new Date(field.fieldAnswerValue);
                                        } else if (field.fieldAnswerLabel != '' && field.fieldAnswerLabel !==null) {
                                            field.fieldAnswerValue = new Date(field.fieldAnswerLabel);
                                        } else {
                                            field.fieldAnswerValue = null
                                        }
                                    }
                                })
                            }
                            /* 
                            If there are existing answers already, add 'changedFields' property
                            for that form entry. This is where changed fields will be pushed.
                            */ 
                            if (response.data.hasAnswers) {
                                this.$set(this.selectedVfe,'changedFields',[]);
                            }
                            /* If there are uploaded files for this entry*/ 
                            if (response.data.files) {
                                this.$set(this.selectedVfe,'files',response.data.files);
                            }
                        }
                    }
                    else {
                        this.promptServerError({response},'Vfe.get');
                    }
                }
                this.vfePromiseLoading = false;
            })
            .catch(error=>{
                this.vfePromiseLoading = false;
                this.promptServerError(error,'Vfe.get');
            });
        },

        addFormEntry(form){

            this.vfePromiseLoading = true;
            VfeApi.getNewEntry(form.formIdFk)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.selectedVfe = {};
                        this.$set(this.selectedVfe,'formIdFk',form.formIdFk);
                        this.$set(this.selectedVfe,'formName',form.formName);
                        this.$set(this.selectedVfe,'formSubmissionType',form.formSubmissionType);
                        this.$set(this.selectedVfe,'displayOption',form.displayOption);
                        this.$set(this.selectedVfe,'sequenceNumber',form.sequenceNumber);
                        this.$set(this.selectedVfe,'formFields',response.data);
                        if (this.selectedForm && this.selectedForm.filesEnabled==true) {
                            this.$set(this.selectedVfe,'files',[]);
                        }
                        this.vfePromiseLoading = false;
                    }
                    else {
                        this.vfePromiseLoading = false;
                        this.promptServerError({response},'Vfe.getNewEntry');
                    }
                }
            })
            .catch(error=>{
                this.vfePromiseLoading = false;
                this.promptServerError(error,'Vfe.getNewEntry');
            });
        },
        closeForm(form){
            if (this.selectedForm) {
                if (this.selectedForm.displayOption=='List') {
                    if (this.selectedVfe) {
                        this.selectedVfe = null;
                    }
                }
                this.selectedForm = null;
            }
            this.showList = true;
        },
        getForms(queryParam){
            var reportingGroup = this.profile.reportingGroup;
            if (queryParam.repGroup) {
                reportingGroup = queryParam.repGroup;
            }
            var validationEntry = {
                reportingGroup : reportingGroup,
                reportingUnit : this.profile.reportingUnit,
                encoder : this.profile.name,
                logs : [],
                forms : []
            }
            if (this.allForms.length==0) {
                // Use form in constant data
                var allForms = FormsData.filter(form=>{
                    return ArrayUtil.inArray(form.reportingGroupAccess,reportingGroup)
                });
            }
            else {
                // Use form in store data
                var allForms = this.allForms.filter(form=>{
                    return ArrayUtil.inArray(form.reportingGroupAccess,reportingGroup)
                });
            }
            validationEntry.forms = allForms;
            this.setValidationEntry(validationEntry);
        },
        prepTableColumns(){
            var selectedFormFields = this.selectedForm.formFields;
        },
        openForm(form){
            this.activeFormEntry = null;
            this.selectedForm = form;
            this.prepTableColumns();
        },
        saveForm(){
            
            if (this.selectedVfe.vcardFormEntryId==undefined) {
                // New Entry Form
                
                // Create new VFE first
                
                // Then create the forms
                
                // Then save the fields

                // Check if there are changes in the form
                console.log(this.selectedVfe.formFields)
                console.log("form fields ^^^")
            }
            else {
                // Save VFE using vcardFormEntryId
                console.log(this.selectedVfe.formFields)
                console.log("form fields ^^^")
                // Save fields answers

                // Log field and field answers
                // by userId
            }

            return false;

            if (this.selectedForm) {
                if (this.activeFormEntry==null) {
                    var entry = {
                        id : this.selectedForm.entries.length,
                        encoder : this.profile.name,
                        dateLastSaved: this.$moment(new Date),
                        submittedForm : this.selectedForm
                    };
                    this.selectedForm.entries.push(entry);
                }
                else {
                    var entryToUpdate = this.selectedForm.entries.filter(entry=>{
                        return entry.id==this.activeFormEntry
                    })
                    if (entryToUpdate.length) {
                        if (entryToUpdate[0]) {
                            entryToUpdate[0].submittedForm = this.selectedForm;
                        }
                    }
                }
            }
        },
        refreshData(){
            if (this.selectedValidationCardId!=null) {
                this.getValidationCard('start');
            }
        },
        openFormTable(form,newDisplayOption){
            
            if (form.displayOption=='Table' || 
                (newDisplayOption && newDisplayOption=='Table')) {
                
                FormsApi.getOne(form.formIdFk)
                .then(response=>{
                    if (response.data) {
                        if (!response.data.error) {
                            this.selectedForm = form;
                            this.selectedForm.formFields = response.data.formFields;
                            this.getFormVfes(this.selectedForm,newDisplayOption);
                        }
                        else {
                            this.promptServerError({response},'Form.getOne');
                        }
                    }
                })
                .catch(error=>{
                    this.promptServerError(error,'Form.getOne');
                });
            }
        },
        getFormVfes(selectedForm,newDisplayOption){
            
            if (this.selectedForm.vfe.length > 0) {
               
                // Get existing answers for each VFE field

                this.selectedForm.vfe.forEach(vfe=>{

                    this.vfePromiseLoading = true;
                    
                    VfeApi.get(vfe.vcardFormEntryId,vfe.formIdFk)
                    .then(response=>{

                        this.$set(vfe,'formFields',[]);
                        this.$set(vfe,'files',[]);
                        this.$set(vfe,'dropFiles',[])
                        this.$set(vfe,'fileUploadError',false)
                        this.$set(vfe,'fileUploadErroMsg','')

                        if (response.data) {
                            if (!response.data.error) {

                                if (response.data.fields) {
                                    
                                    // let currFormFields = response.data.fields;
                                    this.$set(vfe,'formFields',response.data.fields);
                                    /* Parse date field to be consumed by the datepicker element */
                                    if (vfe.formFields.length > 0) {
                                        vfe.formFields.forEach(currField=>{
                                            if (currField.dataType=='string' && currField.fieldAnswerValue==null) {
                                                currField.fieldAnswerValue = "";
                                            }
                                            if (currField.dataType=='date') {
                                                if (currField.fieldAnswerValue!="" && currField.fieldAnswerValue!=null) {
                                                    currField.fieldAnswerValue = new Date(currField.fieldAnswerValue);
                                                }  else if (currField.fieldAnswerLabel != '' && currField.fieldAnswerLabel !==null) {
                                                    currField.fieldAnswerValue = new Date(currField.fieldAnswerLabel);
                                                } else {
                                                    currField.fieldAnswerValue = null
                                                }
                                            }
                                        });
                                    }

                                }
                                /* 
                                If there are existing answers already, add 'changedFields' property
                                for that form entry. This is where changed fields will be pushed.
                                */ 
                                if (response.data.hasOwnProperty('hasAnswers')) {
                                    vfe.changedFields = [];
                                }
                                /* If there are uploaded files for this entry*/ 
                                if (response.data.files) {
                                    let formEntryFiles = response.data.files;
                                    formEntryFiles.forEach(f=>{
                                        /** Convert data */
                                        f.dateUploaded = AppResourceUtil.convertDate(f.dateUploaded)
                                    })
                                    this.$set(vfe,'files',formEntryFiles);
                                }
                                /* If called from changeDisplay() */ 
                                if (newDisplayOption) {
                                    this.selectedForm.displayOption = newDisplayOption;
                                }
                                else {
                                    /** Default display setting if not coming form changeDisplay() */ 
                                    // this.selectedForm.displayOption = selectedForm.displayOption;
                                }

                            }
                            else {
                                this.promptServerError({response},'Vfe.get');
                            }
                        }

                        this.vfePromiseLoading = false;
                    })
                    .catch(error=>{
                        this.vfePromiseLoading = false;
                        this.promptServerError(error,'Vfe.get');
                    });
                });
                
                
            }
        },
        checkFile(){},
        openFile(file){
            if (file.vfeFilePath) {
                var fpath = file.vfeFilePath
                if (file.vfeFilePath.match(/#/gi)) {
                    fpath = file.vfeFilePath.replaceAll('#','%23')
                }
                let t = fpath.split('../');
                if (t[1]) {
                    window.open(this.baseUrl+t[1])
                }
            }
        },
        showVfeFiles(vfe){
            this.openVfeFilesDialog = true;
            this.openedVfe = vfe;
        },
        closeVfeFilesDialog(){
            this.openVfeFilesDialog = false;
            this.openedVfe = null;
        },
        submitError(errorData,api){   
            let obj = {
                email : this.profile.email,
                username : this.profile.username,
                message : "["+errorData.type+" "+errorData.code+"] - "+errorData.message+" Request to: "+api,
                issueStatus : "Pending",
                issueType : "Issue",
                createdBy : this.profile.userId,
                pageName : this.$route.name,
                pageLink : this.$route.path
            };

            if (errorData.hasOwnProperty('query')) {
                obj.message += ' SQL Query: '+errorData.query;
            }

            // Add feedback/issue to DB
            IssueApi.add(obj)
            .then(response=>{
                if (response.data) {
                    if (response.data.issueId) {
                        this.$dialog.alert({
                            title: 'Success',
                            message: "<p><strong>Thanks for reporting!</strong></p><br/>  Admin will check this and get back to you, if necessary.",
                            type: 'is-success'
                        });
                    }
                    else {
                        this.$dialog.alert({
                            title: 'Error',
                            message: "Unable to submit error. Please try again later.",
                            type: 'is-danger'
                        });
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Issue.add');
            });
        },
        promptServerError(error,api){
            try {
                let returnData = AppResourceUtil.getErrorData(error.response);
                if (returnData.errorData!=null) {
                    this.$dialog.confirm({
                        title: returnData.dialog.title,
                        message: returnData.dialog.message,
                        cancelText: "Close",
                        confirmText: "Submit Error",
                        type: 'is-danger',
                        onConfirm: () => {
                            this.submitError(returnData.errorData,api);
                        }
                    });
                }
            } 
            catch(respError){
                console.log(respError)
            }
        },
        setFieldLabel(field) {
            let label = field.fieldLabel //+' ('+fieldeldSubLabel+')'
            if (field.fieldSubLabel) {
                // label += ` (${field.fieldSubLabel})`
            }
            if (field.isRequired==true) {
                label = '*'+label;
            }
            return label;
        },
        showLoading(){
            this.globalLoading = null
            this.globalLoading = this.$loading.open({
                container: null
            })
        },
        closeLoading(){
            if (this.globalLoading !== null) {
                this.globalLoading.close()
            }
            this.globalLoading = null
        },
        getTotalFilesize(files, prop){
            return files.reduce( function(a, b){
                return a + b[prop];
            }, 0)
        },
        getVcardFiles () {
            /** Populate Files Tab */
            this.showLoading()
            
            this.downloadSize = null
            FilesApi.getByVcard(this.selectedValidationCardId)
            .then(response => {
                this.closeLoading()
                var files = response.data    
                if (files && files.length > 0) {
                    files.forEach(file=>{
                        file.dateUploaded = AppResourceUtil.convertDate(file.dateUploaded)
                    })
                    this.downloadSize = AppResourceUtil.convertFileSize(this.getTotalFilesize(files, 'vfeFileSize'))
                }
                if (this.vcardForms.length > 0) {
                    this.vcardForms.forEach(vform => {
                        var formVfeIds = []
                        /** Get vfe ids of form */
                        if (vform.vfe && vform.vfe.length > 0) {
                            formVfeIds = vform.vfe.map(vfe=>{
                                return vfe.vcardFormEntryId
                            })
                        }
                        var allCardFiles = []
                        /** Get files using vfe ids */
                        if (files.length > 0) {
                            allCardFiles = files.filter(file=>{
                                return ArrayUtil.inArray(formVfeIds, file.vcardFormEntryIdFk) === true
                            })
                        }
                        /** Set vcardFiles  */
                        this.$set(vform, 'vcardFiles', allCardFiles)
                    })
                }
            })
            .catch(error=>{
                this.closeLoading()
                this.promptServerError(error,'Files.getByVcard');
            });
        },
        compressFiles () {
            /** Download all files */
            if (this.downloadSize === null) {
                return false
            }
            this.$dialog.confirm({
                title: "Warning",
                message: `This action will compress all files into a .zip file. Total download size is: ${this.downloadSize}. Please expect longer wait time for large download size. <br/><br/><p>To proceed, click 'Continue Download'. Otherwise, click 'Cancel'.</p>`,
                cancelText: "Cancel",
                confirmText: "Continue Download",
                type: 'is-warning',
                onConfirm: () => {
                    FilesApi.compress({
                        reportingYear: this.selectedReportingYear,
                        vcardId: this.intSelectedVcardId,
                        downloadSize: this.downloadSize
                    })
                },
                onCancel: ()=>{
                }
            });
            
        }
    },
    watch: {
        activeTab: function(newVal,oldVal) {
            /** Check if tab is Files */
            if (newVal === 2) { 
                this.getVcardFiles()
            }
        }
    }
}
</script>

<template>
    <section>
        <p class="subtitle page-title">Workspace</p>

        <!-- Reporting Year Selection -->
        <div class="base-box--sidepadded margin-left margin-btm--med">
            <div class="field is-grouped">
                <div class="control">
                    <b-dropdown
                        v-model="selectedReportingYear">
                        <button class="button is-primary is-outlined"
                            type="button"
                            slot="trigger">
                            <template
                                v-if="selectedReportingYear">
                                <strong>Reporting Year ({{selectedReportingYear}})</strong>
                            </template>
                            <template
                                v-else>
                                <strong>Select Reporting Year</strong>
                            </template>
                            <b-icon icon="menu-down"></b-icon>
                        </button>

                        <b-dropdown-item
                            v-for="(year,yearIdx) in reportingYearLov"
                            v-bind:key="yearIdx"
                            v-bind:value="year"
                            v-on:click="selectReportingYear">
                            <h4>{{year}}</h4>
                        </b-dropdown-item>
                        
                    </b-dropdown>
                </div>
                <div class="control"
                    v-if="inProgressVcards.length > 0"
                    style="width:300px"> 
                    
                    <b-autocomplete
                        icon="magnify"
                        placeholder="Choose Validation Card"
                        v-model="vcardKeyword"
                        v-bind:data="filteredVcards"
                        v-bind:open-on-focus="true"
                        v-on:select="selectVcard"
                        :clearable="true"
                        field="displayedEntityName"
                        :max-height="'280px'">
                        <template slot-scope="props">
                            <span class="title is-6">{{props.option.displayedEntityName}}</span><br/>
                            <span class="has-text-weight-ligh">{{props.option.reportingGroup}}</span><br/>
                            <span class="tag"
                                v-bind:class="'tag--'+props.option.validationCardStatusClass">{{props.option.validationCardStatus}}</span>
                        </template>
                        <template slot="empty">No results found</template>
                    </b-autocomplete>


                    <!-- <b-dropdown 
                        class="vcard-dropdown"
                        v-model="selectedValidationCardId" 
                        aria-role="list">
                        <button class="button is-primary" type="button" slot="trigger">
                            <template v-if="vcardDisplayName">
                                <span>{{vcardDisplayName}}</span>
                            </template>
                            <template v-else>
                                <span>Choose Validation Card</span>
                            </template>
                            <b-icon icon="menu-down"></b-icon>
                        </button>

                        <b-dropdown-item 
                            aria-role="listitem"
                            v-for="vcard in inProgressVcards"
                            v-bind:key="vcard.validationCardId"
                            v-bind:value="vcard.validationCardId"
                            v-on:click="selectVcard">
                            <div class="media">
                                <div class="media-content">
                                    <h3 class="has-text-weight-semibold">{{vcard.reportingUnit ? vcard.reportingUnit : vcard.reportingEntity}}</h3>
                                    <small>{{vcard.cardLevel}}</small>
                                </div>
                            </div>
                        </b-dropdown-item>

                    </b-dropdown> -->
                </div>
                <div class="control"
                    v-if="inProgressVcards.length > 0 && selectedValidationCardId">
                    <button type="button"
                        class="button is-light tooltip is-tooltip-top"
                        data-tooltip="Refresh data"
                        v-on:click="refreshData">
                        <span class="icon">
                            <i class="fas fa-redo"></i>
                        </span>
                    </button>
                </div>
            </div>
        </div>

        <div class="base-box--sidepadded margin-left margin-btm--med"
            v-if="selectedValidationCard"
            style="padding-left:0.9rem;">
            <span class="title is-6">{{selectedValidationCard.displayedEntityName}}</span>
            <span class="tag"
                v-bind:class="'tag--'+selectedValidationCard.validationCardStatusClass">{{selectedValidationCard.validationCardStatus}}</span><br/>
            <small>Last Updated by: {{selectedValidationCard.lastUpdatedByName}} on {{selectedValidationCard.dateLastUpdated}}</small>
        </div>

        <section class="section no-padd--top app-view app-view--user"
            v-if="selectedValidationCard!=null && !isLoading"> 

            <b-tabs
                v-model="activeTab"
                type="is-boxed">
                
                <!-- VFEs -->
                <b-tab-item label="Forms"
                    icon-pack="fa"
                    icon="file-alt">

                    <div class="columns">
                        <!-- Forms List -->
                        <div class="column list-panel"
                            v-if="vcardForms.length > 0 && showList==true">
                            <!-- Filter and Search -->
                            <div class="base-box box-wd--fill base-box--tbpadded">
                                <div class="columns">
                                    <div class="column">
                                        <b-field expanded>
                                            <b-input placeholder="Search Form"
                                                type="search"
                                                icon="magnify"
                                                v-model="searchFormKeyword">
                                            </b-input>
                                            <p class="control">
                                                <button class="button is-info">Search</button>
                                            </p>
                                        </b-field>
                                    </div>
                                    <!-- <div class="column has-text-right">
                                        <a class="button is-primary">
                                            <span>
                                                <i class="fas fa-angle-left"></i>
                                            </span>
                                        </a>
                                        <a class="button is-primary">
                                            <span>
                                                <i class="fas fa-angle-right"></i>
                                            </span>
                                        </a>
                                    </div> -->
                                </div>
                            </div>
                            <!-- Main List -->
                            <div>
                                <b-collapse class="card"
                                    v-for="(form,formIdx) in filterValidationEntryForms"
                                    v-bind:key="form.formId"
                                    v-bind:ref="'formIdx'+formIdx">
                                    <div 
                                        slot="trigger"
                                        slot-scope="props"
                                        class="card-header collapse-header">
                                        <p class="card-header-title collapse-title">
                                            <span class="tag is-white has-text-success"
                                                v-if="form.formSubmissionType!='Single'">
                                                {{form.formSubmissionType}}
                                            </span> 
                                            &nbsp; 
                                            {{form.formName}} 
                                        </p>

                                        <!-- Actions -->
                                        <div class="field is-grouped collapse-action">
                                            <!-- <p class="control"
                                                v-if="form.displayOption=='List'">
                                                <a class="button is-link is-inverted tooltip is-tooltip-left"
                                                    data-tooltip="Add new entry"
                                                    v-on:click.stop.prevent="addFormEntry(form,'list')"
                                                    v-if="form.formSubmissionType=='Multiple'">
                                                    <span class="icon">
                                                        <i class="fas fa-plus"></i>
                                                    </span>
                                                </a>
                                            </p> -->
                                            <p class="control"
                                                v-if="form.displayOption=='Table'">
                                                <a class="button is-link is-inverted tooltip is-tooltip-right"
                                                    data-tooltip="Open Form"
                                                    v-on:click.stop.prevent="openFormTable(form)">
                                                    <span class="icon">
                                                        <i class="fas fa-share"></i>
                                                    </span>
                                                </a>
                                            </p>
                                        </div>

                                        <a class="card-header-icon">
                                            <b-icon
                                                v-if="form.displayOption=='List'"
                                                :icon="props.open ? 'menu-up' : 'menu-down'">
                                            </b-icon>
                                        </a>
                                    </div>

                                    <div v-if="form.displayOption=='List'">
                                        <div v-if="form.vfe.length > 0">
                                            <div class="box form-entry-box clickable"
                                                v-for="(entry,entryIdx) in form.vfe"
                                                v-bind:key="entryIdx"
                                                v-bind:class="{'active-form-entry':activeFormEntry!==null && activeFormEntry.id==entry.id && entry.submittedForm.title==selectedForm.title}"
                                                v-on:click="openFormEntry(entry,form)">
                                                <p><strong>Entry ID:</strong> {{entry.vcardFormEntryId}}</p>
                                                <p><strong>Last Updated by:</strong> {{entry.lastUpdatedByName}} on {{entry.dateLastUpdated}}</p>
                                                <!-- <p><strong>Date last updated:</strong> </p> -->
                                            </div>
                                        </div>
                                    </div>
                                </b-collapse>
                            </div>
                        </div>

                        <!-- Workspace/Form View -->
                        <div class="column workspace-panel"
                            v-bind:class="{'is-full':!showList,'is-two-thirds':showList}">
                            
                            <div
                                v-if="selectedForm!=null"
                                class="box">

                                <div class="columns">
                                    <div class="column is-1 has-text-left">
                                        <a class="button is-info tooltip is-tooltip-right"
                                            v-bind:class="{'is-outlined':showList}"
                                            data-tooltip="Hide/show form entries list"
                                            v-on:click="toggleList">
                                            <span>
                                                <i class="fas fa-bars"></i>
                                            </span>
                                        </a>
                                    </div>
                                    <div class="column no-padd">
                                         <p class="title form-name">{{selectedForm.formName}}</p>
                                    </div>
                                    <div class="column is-1 no-padd has-text-right">
                                        <a class="button is-white"
                                            v-on:click="closeForm">
                                            <span class="icon tooltip is-tooltip-top"
                                                data-tooltip="Close form">
                                                <i class="fas fa-times"></i>
                                            </span>
                                        </a>
                                    </div>
                                </div>
                                
                                <!-- Form + Save Actions -->
                                <div class="columns">

                                    <div class="column"
                                        v-if="selectedForm.displayOption=='List' && selectedVfe!=null">
                                        <span class="heading"
                                            v-if="selectedVfe && !selectedVfe.vcardFormEntryId">
                                            New Entry
                                        </span>
                                        <span class="heading"
                                            v-if="selectedVfe && selectedVfe.vcardFormEntryId">
                                            Entry ID: {{selectedVfe.vcardFormEntryId}}
                                        </span>
                                        <i v-if="selectedVfe && selectedVfe.vcardFormEntryId">Last updated by: {{selectedVfe.lastUpdatedByName}} on {{selectedVfe.dateLastUpdated}}</i>
                                    </div>

                                    <div class="column has-text-right">
                                    </div>
                                </div>

                                <!-- Display Options -->
                                <div class="columns">

                                    <div class="column has-text-right">
                                        <a class="button is-info"
                                            v-bind:class="{'is-outlined':selectedForm.displayOption!=='List'}"
                                            v-on:click="changeDisplay('List')">
                                            <span class="icon">
                                                <i class="fas fa-th-list"></i>
                                            </span>
                                        </a>
                                    
                                        <a class="button is-info"
                                            v-bind:class="{'is-outlined':selectedForm.displayOption!=='Table'}"
                                            v-on:click="changeDisplay('Table')">
                                            <span class="icon">
                                                <i class="fas fa-columns"></i>
                                            </span>
                                        </a>
                                    </div>

                                </div>

                                <!-- Fields -->

                                <section class="main-form-body">
                                    
                                    <b-loading 
                                        v-bind:is-full-page="false" 
                                        v-bind:active.sync="vfePromiseLoading" 
                                        v-bind:can-cancel="false"></b-loading>

                                    <!-- List view -->
                                    <div v-if="selectedForm && selectedForm.displayOption=='List'">

                                        <div v-if="selectedVfe && selectedVfe.formFields">

                                            <div 
                                                class="field-group-box"
                                                v-for="(grp,grpIdx) in groupedFields"
                                                v-bind:key="grpIdx">

                                                <p class="subtitle"
                                                    v-if="grp.fieldGroupName!=''"
                                                    style="margin-bottom:0.4rem">{{grp.fieldGroupName}}</p>

                                                <p class="is-7"
                                                    v-if="grp.fieldGroupSubLabel!=null && grp.fieldGroupSubLabel!=''"
                                                    style="margin-bottom:0.9rem">{{grp.fieldGroupSubLabel}}</p>
                                
                                                <div 
                                                    v-for="(field,fieldIdx) in grp.fields"
                                                    v-bind:key="fieldIdx">

                                                    <!-- *** INPUT TEXTS *** -->
                                                    <div class="form-field-label">
                                                        <span class="has-text-weight-bold">{{setFieldLabel(field)}}</span>
                                                        <span v-if="field.fieldSubLabel"><br/>{{field.fieldSubLabel}}</span>
                                                    </div>

                                                    <!-- Textfield -->
                                                    <b-field
                                                        v-if="field.inputType=='textfield'"
                                                        class="form-field-input">
                                                        <b-input 
                                                            type="text"
                                                            v-model="field.fieldAnswerValue"
                                                            disabled></b-input>
                                                    </b-field>

                                                    <!-- Textarea -->
                                                    <b-field
                                                        v-if="field.inputType=='textarea'"
                                                        class="form-field-input">
                                                        <b-input 
                                                            maxlength="500" 
                                                            type="textarea"
                                                            v-model="field.fieldAnswerValue"
                                                            disabled></b-input>
                                                    </b-field>

                                                    <!-- *** NUMBER INPUTS *** -->

                                                    <!-- Number -->
                                                    <b-field
                                                        v-if="field.inputType=='number'"
                                                        class="form-field-input">
                                                        <b-input  
                                                            type="number"
                                                            min="0"
                                                            v-model="field.fieldAnswerValue"
                                                            disabled></b-input>
                                                    </b-field>

                                                    <!-- Decimal -->
                                                    <b-field
                                                        v-if="field.inputType=='decimal'"
                                                        class="form-field-input">
                                                        <b-input  
                                                            type="text"
                                                            v-model="field.fieldAnswerLabel"
                                                            v-bind:value="field.fieldAnswerValue"
                                                            v-cleave="masks.numeral"
                                                            disabled></b-input>
                                                    </b-field>

                                                    <!-- Integer -->
                                                    <b-field
                                                        v-if="field.inputType=='integer'"
                                                        class="form-field-input">
                                                        <b-input  
                                                            type="number"
                                                            v-model="field.fieldAnswerValue"
                                                            disabled></b-input>
                                                    </b-field>

                                                    
                                                    <!-- *** SELECTION INPUTS / WITH OPTIONS *** -->

                                                    <!-- Yes or No -->
                                                    <b-field
                                                        v-if="field.inputType=='yes or no'"
                                                        class="form-field-input">
                                                        <div class="buttons has-addons"
                                                            v-if="field.inputType=='yes or no'">
                                                            <span class="button"
                                                                disabled
                                                                v-bind:class="{'is-info':field.fieldAnswerValue=='Yes'}">Yes</span>
                                                            <span class="button"
                                                                disabled
                                                                v-bind:class="{'is-info':field.fieldAnswerValue=='No'}">No</span>
                                                        </div>
                                                    </b-field>

                                                    <!-- Dropdown -->
                                                    <b-field
                                                        v-if="field.inputType=='dropdown' && field.options.length"
                                                        class="form-field-input">
                                                        <!-- Custom Options -->
                                                        <b-select
                                                            v-if="field.optionType=='custom' && field.options.length > 0"
                                                            v-model="field.fieldAnswerValue"
                                                            disabled>
                                                            <option v-for="opt in field.options"
                                                                v-bind:key="opt.optionId"
                                                                v-bind:value="opt.optionValue">
                                                                {{opt.optionValue}}
                                                            </option>
                                                        </b-select>

                                                        <!-- Preset Options -->
                                                        <b-select
                                                            v-if="field.optionType=='preset' && field.options.length==1 && 
                                                            field.options[0].optionValue=='Reporting Entities'"
                                                            v-model="field.fieldAnswerValue"
                                                            disabled>
                                                            <option 
                                                                v-for="(opt,optIdx) in presetLovs['Reporting Entities']"
                                                                v-bind:key="optIdx"
                                                                v-bind:value="opt.optionValue">
                                                                {{opt.optionLabel}}
                                                            </option>
                                                        </b-select>

                                                        <b-select
                                                            v-if="field.optionType=='preset' && field.options.length==1 && 
                                                            field.options[0].optionValue=='Reporting Entities & Units'"
                                                            v-model="field.fieldAnswerValue"
                                                            disabled>
                                                            <option 
                                                                v-for="(opt,optIdx) in presetLovs['Reporting Entities & Units']"
                                                                v-bind:key="optIdx"
                                                                v-bind:value="opt.optionValue">
                                                                {{opt.optionLabel}}
                                                            </option>
                                                        </b-select>
                                                        
                                                    </b-field>

                                                    <!-- Checkbox -->
                                                    <b-field
                                                        v-if="field.inputType=='checkbox' && field.options.length"
                                                        class="form-field-input">
                                                        <div class="block checkbox-block">
                                                            <b-checkbox v-for="opt in field.options"
                                                                v-bind:key="opt.optionId"
                                                                v-model="field.fieldAnswerValue"
                                                                v-bind:native-value="opt.optionValue"
                                                                disabled>
                                                                {{opt.optionValue}}
                                                            </b-checkbox>
                                                        </div>
                                                    </b-field>

                                                    <!-- Radio -->
                                                    <b-field
                                                        v-if="field.inputType=='radio' && field.options.length"
                                                        class="form-field-input">
                                                        <div class="block radio-block">
                                                            <b-radio 
                                                                v-for="opt in field.options"
                                                                v-bind:key="opt.optionId"
                                                                v-bind:name="'radio'+field.fieldId"
                                                                v-bind:native-value="opt.optionValue"
                                                                v-model="field.fieldAnswerValue"
                                                                disabled>
                                                                {{opt.optionValue}}
                                                            </b-radio>
                                                        </div>
                                                    </b-field>

                                                    <!-- *** DATE INPUT *** -->

                                                    <!-- Date Inputs -->
                                                    <b-field
                                                        v-if="field.inputType=='date' || 
                                                              field.inputType=='date range (start date)' ||
                                                              field.inputType=='date range (end date)'"
                                                        class="form-field-input">
                                                        <b-datepicker
                                                            v-bind:show-week-number="true"
                                                            disabled
                                                            placeholder="Click to select date"
                                                            v-bind:model="field.fieldAnswerValue"
                                                            icon="calendar-today">
                                                        </b-datepicker>
                                                    </b-field>
                                                    
                                                </div>

                                            </div>
                                        </div>

                                        <hr v-if="selectedForm && selectedForm.filesEnabled && selectedForm.displayOption=='List'"/>

                                        <div
                                            v-if="selectedForm && selectedForm.filesEnabled && selectedForm.displayOption=='List'" 
                                            class="box">
                                            <h3 class="subtitle is-6 has-text-weight-bold">Add Supporting Schedules and Documents</h3>
                                            <ul v-if="selectedVfe && selectedVfe.files.length > 0"
                                                class="vfe-files-list">
                                                <li v-for="(file,fileIdx) in selectedVfe.files"
                                                    v-bind:key="fileIdx">
                                                   
                                                    <span class="subtitle">{{file.vfeFileTitle}}</span>
                                                    <div class="has-text-left">
                                                        Uploaded by {{file.uploadedByName}} on 
                                                        {{file.dateUploaded}}
                                                    </div>
                                                    <div class="buttons">
                                                        <a class="button is-light"
                                                            type="button"
                                                            v-on:click="openFile(file)">
                                                            <span class="icon">
                                                                <i class="fas fa-external-link-alt"></i>
                                                            </span>
                                                            <span>Open</span>
                                                        </a>
                                                    </div>
                                                    
                                                </li>
                                            </ul>
                                            <b-message 
                                                type="is-info">
                                                <ul>
                                                    <li>- Only .pdf, .ppt/.pptx, .doc/docx, and .xls/xlsx are supported.</li>
                                                    <li>- Multiple files can be uploaded but not more than a total of 20 files.</li> 
                                                    <li>- Total file size should NOT be more than 100MB.</li>
                                                    <li>- In case total file size exceeds 100MB, remove a few files then upload again after clicking 'Save'.</li>
                                                    <li>- Files with the same filename will be overwritten upon selection</li> 
                                                    <li>- For large files, a loading screen will show up to indicate that the upload is still in progress. </li>
                                                    <li>- DO NOT CLOSE this page while the upload is ongoing.</li>
                                                </ul>
                                            </b-message>
                                            <!-- <b-notification 
                                                v-bind:active.sync="fileUploadError" 
                                                type="is-danger"
                                                aria-close-label="Close notification"
                                                role="alert">
                                                {{fileUploadErroMsg}}
                                            </b-notification> -->
                                            <b-field>
                                                <b-upload 
                                                    disabled>
                                                    <section class="section">
                                                        <div class="content has-text-centered">
                                                            <p>
                                                                <b-icon
                                                                    icon="upload"
                                                                    size="is-large">
                                                                </b-icon>
                                                            </p>
                                                            <p>Drop your files here or click to upload</p>
                                                        </div>
                                                    </section>
                                                </b-upload>
                                            </b-field>
                                        </div>
                                        
                                        <!-- <hr /> -->
                                        
                                    </div>

                                    <!-- Table View -->
                                    <div v-if="selectedForm && selectedForm.displayOption=='Table'"
                                        class="ore-table-wrapper"
                                        v-bind:class="{'ore-table-wrapper--expanded' : !showList }">

                                        <table class="ore-table">
                                            <thead>
                                                <tr v-if="selectedForm && selectedForm.formFields.length > 0">
                                                    <th v-for="(col,colIdx) in selectedForm.formFields"
                                                        v-bind:key="colIdx"
                                                        style="min-width:100px;max-width:200px;">
                                                        <span v-if="col.fieldGroupLabel" class="form-field-grouplabel-th">{{col.fieldGroupLabel}} - </span>
                                                        {{col.fieldLabel}} <span class="form-field-sublabel-th" v-if="col.fieldSubLabel"><br/>{{col.fieldSubLabel}}</span>
                                                    </th>
                                                    <th v-if="selectedForm && selectedForm.filesEnabled"
                                                        style="min-width:100px;max-width:200px;">
                                                        Supporting Schedules and Documents
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="selectedForm && selectedForm.vfe.length > 0">
                                                <tr v-for="(vfe,vfeIdx) in selectedForm.vfe"
                                                    v-bind:key="vfeIdx">
                                                    <td v-for="(col,colIdx) in vfe.formFields"
                                                        v-bind:key="colIdx"
                                                        style="min-width:100px;max-width:200px;">
                                                        <!-- *** INPUT TEXTS *** -->

                                                        <!-- Textfield -->
                                                        <b-field
                                                            v-if="col.inputType=='textfield'">
                                                            <b-input 
                                                                type="text"
                                                                v-model="col.fieldAnswerValue"
                                                                disabled></b-input>
                                                        </b-field>
                                                        
                                                        <!-- Textarea -->
                                                        <b-field
                                                            v-if="col.inputType=='textarea'">
                                                            <b-input 
                                                                maxlength="500" 
                                                                type="textarea"
                                                                v-model="col.fieldAnswerValue"
                                                                disabled></b-input>
                                                        </b-field>

                                                       <!-- *** NUMBER INPUTS *** -->

                                                        <!-- Number -->
                                                        <b-field
                                                            v-if="col.inputType=='number'">
                                                            <b-input  
                                                                type="number"
                                                                min="0"
                                                                v-model="col.fieldAnswerValue"
                                                                disabled></b-input>
                                                        </b-field>

                                                        <!-- Decimal -->
                                                        <b-field
                                                            v-if="col.inputType=='decimal'">
                                                            <b-input  
                                                                type="text"
                                                                v-model="col.fieldAnswerLabel"
                                                                v-bind:value="col.fieldAnswerValue"
                                                                v-cleave="masks.numeral"
                                                                disabled></b-input>
                                                        </b-field>

                                                        <!-- Integer -->
                                                        <b-field
                                                            v-if="col.inputType=='integer'">
                                                            <b-input  
                                                                type="number"
                                                                min="0"
                                                                v-model="col.fieldAnswerValue"></b-input>
                                                        </b-field>

                                                        <!-- *** SELECTION INPUTS / WITH OPTIONS *** -->

                                                         <!-- Yes or No -->
                                                        <b-field
                                                            v-if="col.inputType=='yes or no'">
                                                            <div class="buttons has-addons"
                                                                v-if="col.inputType=='yes or no'">
                                                                <span class="button"
                                                                    v-bind:class="{'is-info':col.fieldAnswerValue=='Yes'}"
                                                                    disabled>Yes</span>
                                                                <span class="button"
                                                                    v-bind:class="{'is-info':col.fieldAnswerValue=='No'}"
                                                                    disabled>No</span>
                                                            </div>
                                                        </b-field>
                                                        
                                                        <!-- Dropdown -->
                                                        <b-field
                                                            v-if="col.inputType=='dropdown' && col.options.length">
                                                            <!-- Custom Options -->
                                                            <b-select
                                                                v-if="col.optionType=='custom' && col.options.length > 0"
                                                                v-model="col.fieldAnswerValue"
                                                                disabled>
                                                                <option v-for="opt in col.options"
                                                                    v-bind:key="opt.optionId"
                                                                    v-bind:value="opt.optionValue">
                                                                    {{opt.optionValue}}
                                                                </option>
                                                            </b-select>

                                                            <!-- Preset Options -->
                                                            <b-select
                                                                v-if="col.optionType=='preset' && col.options.length==1 && 
                                                                col.options[0].optionValue=='Reporting Entities'"
                                                                v-model="col.fieldAnswerValue"
                                                                disabled>
                                                                <option 
                                                                    v-for="(opt,optIdx) in presetLovs['Reporting Entities']"
                                                                    v-bind:key="optIdx"
                                                                    v-bind:value="opt.optionValue">
                                                                    {{opt.optionLabel}}
                                                                </option>
                                                            </b-select>

                                                            <b-select
                                                                v-if="col.optionType=='preset' && col.options.length==1 && 
                                                                col.options[0].optionValue=='Reporting Entities & Units'"
                                                                v-model="col.fieldAnswerValue"
                                                                disabled>
                                                                <option 
                                                                    v-for="(opt,optIdx) in presetLovs['Reporting Entities & Units']"
                                                                    v-bind:key="optIdx"
                                                                    v-bind:value="opt.optionValue">
                                                                    {{opt.optionLabel}}
                                                                </option>
                                                            </b-select>
                                                            
                                                        </b-field>

                                                        <!-- Checkbox -->
                                                        <b-field
                                                            v-if="col.inputType=='checkbox' && col.options.length">
                                                            <div class="block checkbox-block">
                                                                <b-checkbox v-for="opt in col.options"
                                                                    v-bind:key="opt.optionId"
                                                                    v-bind:native-value="opt.optionValue"
                                                                    v-model="col.fieldAnswerValue"
                                                                    disabled>
                                                                    {{opt.optionValue}}
                                                                </b-checkbox>
                                                            </div>
                                                        </b-field>

                                                        <!-- Radio -->
                                                        <b-field
                                                            v-if="col.inputType=='radio' && col.options.length">
                                                            <div class="block radio-block">
                                                                <b-radio 
                                                                    v-for="opt in col.options"
                                                                    v-bind:key="opt.optionId"
                                                                    v-bind:name="'radio'+col.fieldId"
                                                                    v-bind:native-value="opt.optionValue"
                                                                    v-model="col.fieldAnswerValue"
                                                                    disabled>
                                                                    {{opt.optionValue}}
                                                                </b-radio>
                                                            </div>
                                                        </b-field>

                                                        <!-- *** DATE INPUT *** -->

                                                        <!-- Date Inputs -->
                                                        <b-field
                                                            v-if="col.inputType=='date' || 
                                                                  col.inputType=='date range (start date)' ||
                                                                  col.inputType=='date range (end date)'">
                                                                <b-datepicker
                                                                    v-bind:show-week-number="true"
                                                                    disabled
                                                                    placeholder="Click to select date"
                                                                    icon="calendar-today"
                                                                    v-bind:model="col.fieldAnswerValue">
                                                                </b-datepicker>
                                                        </b-field>

                                                    </td>
                                                    <td v-if="selectedForm && selectedForm.filesEnabled">
                                                        <b-field grouped>
                                                            <a 
                                                                v-if="vfe && vfe.files && vfe.files.length > 0"
                                                                class="button has-text-weight-bold"
                                                                type="button"
                                                                v-on:click="showVfeFiles(vfe)">    
                                                                <i class="fas fa-file"></i>&nbsp;
                                                                <span>Files ({{vfe.files.length}})</span>
                                                            </a> &nbsp;&nbsp;

                                                            <b-field class="file"
                                                                v-if="vfe && vfe.dropFiles">
                                                                <b-upload 
                                                                    v-model="vfe.dropFiles"
                                                                    multiple
                                                                    disabled>
                                                                    <a class="button is-primary is-outlined">
                                                                        <b-icon icon="upload"></b-icon>
                                                                        <span>Choose file</span>
                                                                    </a>
                                                                </b-upload>
                                                            </b-field>
                                                        </b-field>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tbody v-if="selectedForm">
                                                <tr v-if="selectedForm && selectedForm.vfe.length == 0 && selectedForm.formFields">
                                                    <td v-bind:colspan="selectedForm.formFields.length">
                                                        No entries available.
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td v-bind:colspan="selectedForm.formFields.length + 1">
                                                        <a class="button is-light"
                                                            v-if="selectedForm && selectedForm.formSubmissionType=='Multiple' && selectedForm.displayOption=='Table'"
                                                            disabled>
                                                            <span class="icon">
                                                                <i class="fas fa-plus"></i>
                                                            </span>
                                                            <span>Add New Entry</span>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </section>
                            </div>
                            
                             <!-- Empty State -->
                            <div v-if="selectedForm==null"
                                class="base-box  box-hw--fill base-box--padded empty-state-box">
                                <!-- Add image here -->
                                <p class="title has-text-grey-light">No form selected</p>
                                <p class="subtitle has-text-grey-light">Please select one from the list to your left.</p>
                            </div>

                            <div v-if="selectedForm && selectedForm.displayOption!='Table' && selectedVfe==null"
                                class="base-box  box-hw--fill base-box--padded empty-state-box">
                                <!-- Add image here -->
                                <p class="title has-text-grey-light">No form selected</p>
                                <p class="subtitle has-text-grey-light">Please select one from the list to your left.</p>
                            </div>
                        </div>

                    </div>
                </b-tab-item>

                <!-- Show Logs Here -->
                <b-tab-item label="Logs"
                    icon-pack="fa"
                    icon="user-clock">
                    <div v-if="vcardLogs.length==0"
                        class="base-box  box-hw--fill base-box--padded empty-state-box">
                        <p class="title has-text-grey-light">No logs found</p>
                    </div>

                    <div v-if="vcardLogs.length > 0">
                        <div class="timeline">
                            <!-- Show this if status is validated and submitted already -->
                            <header class="timeline-header"
                                v-if="selectedValidationCard && selectedValidationCard.validationCardStatus=='Validated and Submitted'">
                                <span class="tag is-medium is-dark">End </span>
                            </header>
                            <div class="timeline-item"
                                v-for="log in vcardLogs"
                                v-bind:key="log.logId">
                                <div class="timeline-marker">
                                </div>
                                <div class="timeline-content">
                                    <p class="heading">{{log.activityDate}} by {{log.activityByUserName}}</p>
                                    <p>{{log.activityMessageLog}}</p>
                                    <p
                                        v-if="log.additionalInfo"
                                        class="is-italic">
                                        {{log.additionalInfo.activity}}
                                    </p>
                                    <p
                                        v-if="log.activityReason">
                                        <strong>Reason :</strong> {{log.activityReason}}
                                    </p>
                                    <p v-if="log.activitySection=='Validation Card - Form Entry'"><span class="has-text-weight-bold">Form Name:</span> {{log.formName}}</p>
                                    <div v-if="log.activityBody && !log.activityReason">
                                        <table 
                                            width="100%"
                                            cellpadding="5"
                                            cellspacing="6"
                                            class="activity-log-table"
                                            v-if="log.changedFields">
                                            <thead>
                                                <tr>
                                                    <th>Field</th>
                                                    <th>Old Value</th>
                                                    <th>New Value</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr 
                                                    v-for="(ch,chIdx) in log.changedFields"
                                                    v-bind:key="chIdx">
                                                    <td>{{ch.fieldLabel}}</td>
                                                    <td>
                                                        <span class="strikethrough">{{ch.oldValue}}</span>
                                                    </td>
                                                    <td>{{ch.newValue}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <p v-else
                                            class="is-italic">
                                            {{log.activityBody}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <header class="timeline-header">
                                <span class="tag is-medium is-dark">Start</span>
                            </header>
                        </div>
                    </div>
                </b-tab-item>

                <b-tab-item label="Files"
                    icon-pack="fa"
                    icon="folder-open">
                    <!-- <div class="field">
                        <b-radio 
                            v-model="withFiles">
                            Show forms with supporting schedules and documents
                        </b-radio>
                    </div> -->
                    <div class="columns">
                        <div class="column">
                            <b-field>
                                <b-switch v-model="withFiles">
                                    Only show forms with supporting schedules and documents
                                </b-switch>
                            </b-field>
                        </div>
                        <div class="column is-2 has-text-right">
                            <a class="button is-light"
                                v-if="downloadSize !== null && isAdmin"
                                type="button"
                                v-on:click="compressFiles"
                                style="margin-top:0.4rem"
                                title="Click to download files">
                                <span class="icon">
                                    <i class="fas fa-file-archive"></i>
                                </span>
                                <span>Download ({{downloadSize}})</span>
                            </a>
                        </div>
                    </div>
                    
                    <div class="columns is-multiline"
                        v-if="formsWithFiles && formsWithFiles.length > 0">
                        <div class="column is-one-third"
                            v-for="(vform,vformIdx) in formsWithFiles"
                            :key="vformIdx">
                            <div class="box">
                                <span class="has-text-weight-semibold">{{vform.formName}} ({{vform.vcardFiles.length}})</span>
                                <ul v-if="vform.vcardFiles && vform.vcardFiles.length > 0"
                                    class="vfe-files-list"
                                    style="margin-top:1rem">
                                    <li v-for="(file,fileIdx) in vform.vcardFiles"
                                        v-bind:key="fileIdx"
                                        style="padding:0px;"
                                        class="columns">                            
                                        <div class="column is-1">
                                            <a class="button is-light is-small"
                                                type="button"
                                                v-on:click="openFile(file)"
                                                style="margin-top:0.4rem"
                                                title="Click to open file">
                                                <span class="icon">
                                                    <i class="fas fa-external-link-alt"></i>
                                                </span>
                                            </a>
                                        </div>
                                        <div class="column">
                                            <span class="has-text-info"
                                                style="font-size:13px;cursor:pointer"
                                                v-on:click="openFile(file)">{{file.vfeFileTitle}}</span>
                                            <div class="has-text-left"
                                            style="font-size:12px">
                                                Uploaded by {{file.uploadedByName}} on 
                                                {{file.dateUploaded}}
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <p v-else
                                style="font-size:13px;">No supporting schedules and documents uploaded.</p> 
                            </div>
                        </div>
                    </div>
                    <div v-else
                        class="text-center">
                        <span>No forms found.</span>
                    </div>
                </b-tab-item>

                <b-tab-item label="Preview"
                    icon-pack="fas"
                    icon="eye">
                    <SummaryTab 
                        v-if="selectedValidationCardId"
                        :selectedVcardId="intSelectedVcardId" />
                </b-tab-item>

            </b-tabs>

        </section>

        <section class="base-box--loading"
            v-if="isLoading">
            <b-loading 
                v-bind:is-full-page="isFullPage" 
                v-bind:active.sync="isLoading"
                >
                <b-icon
                    pack="fas"
                    icon="sync-alt"
                    size="is-medium"
                    custom-class="fa-spin">
                </b-icon>
                &nbsp;&nbsp;&nbsp;
                <span class="title is-5">Loading workspace</span>
            </b-loading>
        </section>

        <!-- Empty State -->
        <section class="section no-padd--top app-view app-view--user"
            v-if="!selectedValidationCardId && !isLoading">
            <div
                class="has-text-centered empty-state-box empty-state-box--white padd-top--lrg" >
                <div class="has-text-centered"
                    v-if="inProgressVcards.length > 0">
                    <p class="title is-5">There's no selected validation card.</p>
                    <p class="subtitle">To get started, select from the dropdown next to Reporting Year.</p>
                </div>
                <div class="has-text-centered"
                    v-if="inProgressVcards.length == 0">
                    <p class="title is-5">There are no validation cards that are 'In Progress' for the selected reporting year.</p>
                </div>
            </div>   
        </section>
        
        <!-- VFE Files (for table view) -->
        <b-modal
            has-modal-card
            v-bind:active.sync="openVfeFilesDialog"
            v-on:close="closeVfeFilesDialog">
            <div class="modal-card"
                v-if="openedVfe">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{openedVfe.formName}}</p>
                </header>
                <section class="modal-card-body">
                    <p class="subtitle is-4">Supporting Schedules and Documents ({{openedVfe.files.length}})</p>
                    <p v-if="openedVfe.files.length==0">No supporting schedules and documents uploaded.</p> 
                    <ul v-if="openedVfe && openedVfe.files.length > 0"
                        class="vfe-files-list">
                        <li v-for="(file,fileIdx) in openedVfe.files"
                            v-bind:key="fileIdx">                            
                            <span class="subtitle is-5">{{file.vfeFileTitle}}</span>
                            <div class="has-text-left">
                                Uploaded by {{file.uploadedByName}} on 
                                {{file.dateUploaded}}
                            </div>
                            <div class="buttons">
                                <!-- <a class="button is-light"
                                    type="button"
                                    v-on:click="confirmDeleteFile(file,fileIdx)">
                                    <span class="icon">
                                        <i class="fas fa-trash-alt"></i>
                                    </span>
                                    <span>Delete</span>
                                </a> -->
                                <a class="button is-light"
                                    type="button"
                                    v-on:click="openFile(file)">
                                    <span class="icon">
                                        <i class="fas fa-external-link-alt"></i>
                                    </span>
                                    <span>Open</span>
                                </a>
                            </div>
                        </li>
                    </ul>
                </section>
                <footer class="modal-card-foot has-text-left">
                    <a class="button is-white"
                        v-on:click="closeVfeFilesDialog">
                        <span>Close</span>
                    </a>
                </footer>
            </div>
        </b-modal>
    </section>
</template>

<style scoped>
/* List Panel */
.collapse-header {
    background-color: whitesmoke;
}
.collapse-action {
    margin-top: 0.6em;
}
.form-entry-box {
    border-radius: 0px;
    margin: 0px;
    margin-bottom: 0px !important;
}
.new-form-entry-box {
    padding: 1em;
}
.add-entry {
    border-radius: 0px;
    box-shadow: none;
    border: 2px dashed rgb(230, 230, 230);
}
.active-form-entry {
    font-weight: bold;
    border: 2px solid rgb(255, 187, 0);
}
/* Workspace Panel */
.app-view .b-tabs {
    height: 100%;
    min-height:100%;
}
.workspace-panel {
    min-height:100%;
}
.main-form-body {
    /* max-height:265px;
    overflow-y:scroll;
    overflow-x:hidden; */
}
.form-name {
    margin-top: 0.83rem;
    margin-bottom: 0.4rem !important;
}
.vfe-files-list {
    margin-bottom:2rem;
}
.vfe-files-list li {
    padding: 0.75rem;
    border-bottom:1px solid #efefef;
}
.vfe-files-list li:last-child {
    border-bottom:0px solid transparent;
}
.vfe-files-list li .subtitle {
    margin-top: 0.45rem;
}
.app-view--user {
    min-height: 40vh;
    max-height: 60vh;
    overflow-y: scroll;
}

.checkbox-block > .checkbox,
.radio-block > .radio {
    margin-top: 0.6rem;
    margin-left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/workspace/WorkspacePreview.vue